import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class AdminShippingProviderApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.MANAGEMENT_SHIPPING_PROVIDER);
  }

  updateShippingProviderOrder(data) {
    return this.httpClient.patch(`${this.getResourceUrl()}reorder/`, data);
  }
}

export default new AdminShippingProviderApi();
